import { Edit } from 'react-admin'

import PlaylistForm from './PlaylistForm'

const PlaylistEdit = props => (
  <Edit {...props}>
    <PlaylistForm />
  </Edit>
)

export default PlaylistEdit
